import { Violation } from '../modules/core/services/violation.contract';

export function productRecommendationDocumentViolationsCleared(
  violations: Violation[]
): boolean {
  let sections = Array.from(violations.groupBy((v) => v.section).keys());
  return (
    sections.length == 0 ||
    (sections.length == 1 && sections[0] == 'Discussion Notes')
  );
}
